<div class="dropdown-header">{{ header }}</div>

@if (state$ | async; as state) {
  <input #inputElement [value]="state.search" (input)="onSearchChange($event.target.value)"
    (keydown.arrowdown)="onArrowDown($event)" (keydown.arrowup)="onArrowUp($event)" (keyup.enter)="onEnter()" (keyup.escape)="onEscape()">

  <div class="dropdown-separator"></div>

  @if (state.searchResult) {
    <div>
      @for (vm of state.searchResult; track vm.id) {
        <div class="dropdown-item" [class.selected]="$index === state.highlighted" [title]="vm.label" (click)="onItemClick(vm.item)">{{ vm.label }}</div>
      }
    </div>
  }

  <!-- creating is a row the planner sees and picks, not a side effect of Enter (0110) -->
  @if (showsCreateRow(state)) {
    @if (state.searchResult?.length) {
      <div class="dropdown-separator"></div>
    }

    <div class="dropdown-item dropdown-create" [class.selected]="state.highlighted === (state.searchResult?.length ?? 0)"
      [title]="'Utwórz „' + state.search!.trim() + '”'" (click)="onCreateClick()">+ Utwórz „{{ state.search!.trim() }}”</div>
  }
}
